import { useTheme } from "@/src/styles/theme-provider";
import React from "react";
import { useTranslation } from "react-i18next";
import { Text, View } from "react-native";

export type IconProps = Readonly<{
  color?: string;
  size?: number;
}>;

type StatsCardProps = Readonly<{
  count: number;
  text: string;
  icon: React.ReactElement<IconProps>;
}>;

const StatsCard = ({ count, text, icon }: StatsCardProps) => {
  const { t } = useTranslation();
  const { themeVars } = useTheme();

  const coloredIcon = React.isValidElement(icon)
    ? React.cloneElement(icon, { color: "white" })
    : icon;

  const translatedText = text ? t(text) : "";

  return (
    <View className="flex-row w-[48%] md:w-auto md:flex-1 gap-3 p-3 rounded-2xl items-center min-w-0 bg-chalk md:bg-transparent md:gap-2 md:border md:border-ash-3">
      <View className="flex md:hidden lg:flex justify-center items-center p-2.5 bg-primary rounded-xl aspect-[1/1] shrink-0">
        {coloredIcon}
      </View>
      <View className="flex-1 flex-col min-w-0">
        <Text className="text-xl font-medium text-onyx" numberOfLines={1}>
          {count}
        </Text>
        <Text className="text-slate text-xs" numberOfLines={1}>
          {translatedText}
        </Text>
      </View>
    </View>
  );
};

export default StatsCard;
